import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  // 1. 首页
  { path: '/', name: 'MyIndex', component: Home },
  // 2. 登录
  { path: '/login', name: 'login', component: () => import('../views/Login.vue') },
  // 3. 注册
  { path: '/register', name: 'register', component: () => import('../views/Register.vue') },
  // 4. 找回密码
  { path: '/forgot', name: 'forgot', component: () => import('../views/Forgot.vue') },
  // 5. 服务介绍
  { path: '/service', name: 'service', component: () => import('../views/Service.vue') },
  // 6. 隐私条款
  { path: '/privacy', name: 'privacy', component: () => import('../views/Privacy.vue') },
  // 7. 意见表单
  { path: '/feedback', name: 'feedback', component: () => import('../views/Feedback.vue') },
  // 7. 意见表单
  { path: '/message', name: 'message', component: () => import('../views/Message.vue') },
  // 8. 个人中心
  { path: '/user', name: 'user', component: () => import('../views/User.vue') },
  // 9. 公司列表 = 企业搜索（你要的）
  { path: '/Company', name: 'Business', component: () => import('../views/Company.vue') },
  // 10. 企业主页
  { path: '/company-home', name: 'companyHome', component: () => import('../views/CompanyHome.vue') },
  // 10. 个人主页
  { path: '/user-home', name: 'userHome', component: () => import('../views/UserHome.vue') },
  // 11. 编辑企业主页
  { path: '/company-edit', name: 'companyEdit', component: () => import('../views/CompanyEdit.vue') },
  // 12. 论坛帖子编辑
  { path: '/post-edit', name: 'postEdit', component: () => import('../views/PostEdit.vue') },
  // 13. 需求详情
  { path: '/Netails', name: 'Netails', component: () => import('../views/Netails.vue') },
  // 13. 帖子详情
  { path: '/post-detail', name: 'postDetail', component: () => import('../views/PostDetail.vue') },
  // 14. 帖子列表
  { path: '/Forum', name: 'Forum', component: () => import('../views/Forum.vue') },
  // 14. 需求社区
  { path: '/demand', name: 'demand', component: () => import('../views/Demand.vue') },
  // 15. 需求帖子编辑
  { path: '/demand-edit', name: 'demandEdit', component: () => import('../views/DemandEdit.vue') },
  // 16. 视频浏览
  { path: '/video', name: 'video', component: () => import('../views/Video.vue') },
  // 16. 视频详情
  { path: '/videodel', name: 'videodel', component: () => import('../views/Videodel.vue') },
  // 17. 视频发布
  { path: '/video-publish', name: 'videoPublish', component: () => import('../views/VideoPublish.vue') },
  // 18. 收藏企业用户
  { path: '/collect-company', name: 'collectCompany', component: () => import('../views/CollectCompany.vue') },
  // 19. 收藏需求贴
  { path: '/collect-demand', name: 'collectDemand', component: () => import('../views/CollectDemand.vue') },
  // 20. 通知消息列表
  { path: '/notice', name: 'notice', component: () => import('../views/Notice.vue') },
  // 20. 通知消息列表
  { path: '/noticedel', name: 'noticedel', component: () => import('../views/Noticedel.vue') },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
      // 始终滚动到顶部
      return { top: 0 }
    },
})

export default router